import { TPageContentPaddingTop } from '@/types/global';
import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const Main = styled.main.withConfig({
  shouldForwardProp: (prop) => !['contentPaddingTop'].includes(prop),
})<{
  contentPaddingTop: TPageContentPaddingTop;
}>`
  min-height: 100vh;
  width: 100vw;
  padding-top: ${({ contentPaddingTop }) =>
    `var(--mg-top-page-${contentPaddingTop})`} !important;
  animation: fadeIn 0.4s ease-in-out;

  &[data-theme='dark'] ~ footer {
    .logo-container-link {
      filter: invert(1);
    }
  }

  ${medias.max.mobile} {
    .banner-text-home {
      h2 {
        display: none;
      }
    }

    .prefooter-banner {
      margin-bottom: var('--spacing-component-inner-xl');

      .side-text {
        margin-bottom: 0;
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .footer-contact,
  .footer-contact-num,
  .footer-contact-cv {
    cursor: pointer;
    display: contents;
  }
`;

export const BlockedByLogin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`;
